import { render } from "./Main.vue?vue&type=template&id=54d2cf39"
const script = {}
script.render = render

export default script